import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { LinkedInIconSecondary, XIcon } from '../../../../components/Icons';
interface ShareButtonsProps {
  slug: string;
  className?: string;
}

const generateShareUrls = (slug: string, shareText: string) => {
  const twinUrl = `${window.location.origin}/${slug}`;
  const hashtags = 'Napster,DigitalTwin';

  return {
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      twinUrl,
    )}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      twinUrl,
    )}&text=${encodeURIComponent(shareText)}&hashtags=${encodeURIComponent(
      hashtags,
    )}`,
    twinUrl,
  };
};

export const ShareButtons: React.FC<ShareButtonsProps> = ({
  slug,
  className = '',
}) => {
  const { t } = useTranslation();
  const shareUrls = generateShareUrls(slug, t('twin.shareText'));

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(shareUrls.twinUrl)
      .then(() => {
        toast.success(t('twin.linkCopied'));
      })
      .catch((error) => {
        console.error('Failed to copy link to clipboard:', error);
        toast.error(t('twin.copyFailed'));
      });
  };

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <button className="btn btn-primary !border-0" onClick={handleCopyLink}>
        <i className="fa-solid fa-copy text-lg me-2" />
        {t('twin.copyLink')}
      </button>
      <a
        href={shareUrls.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className="btn bg-[#0A66C2] !border-0 hover:bg-[#004281] ">
        <LinkedInIconSecondary />
        <span className="hidden sm:inline ms-2">{t('twin.shareOnLinkedIn')}</span>
      </a>
      <a
        href={shareUrls.twitter}
        target="_blank"
        rel="noopener noreferrer"
        className="btn !bg-black !border !border-black">
        <XIcon />
        <span className="hidden sm:inline ms-2">{t('twin.shareOnX')}</span>
      </a>
    </div>
  );
};
